import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ShopGroupAccordion = ({ group, expanded, onToggle, onItemClick }) => {
  return (
    <Accordion
      expanded={expanded}
      onChange={onToggle}
      disableGutters
      elevation={0}
      sx={{
        bgcolor: "transparent",
        boxShadow: "none",
        "&:before": { display: "none" }, // remove default divider
      }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          px: 1.5,
          py: 1.1,
          fontSize: "16px",
          minHeight: "unset", // override default height
          "&.Mui-expanded": {
            minHeight: "unset", // override when expanded
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
            fontWeight: 600,
          },
          "&:hover": {
            backgroundColor: "#FAFAFA",
          },
        }}>
        {group.label}
      </AccordionSummary>

      <AccordionDetails sx={{ px: 0 }}>
        {group.items?.map((item) => (
          <Box
            key={item.label}
            onClick={() => onItemClick(item.path, item.isActive)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",

              py: 0.75,
              px: 1.5,
              borderRadius: 2,
              cursor: item.isActive ? "pointer" : "default",
              color: item.isActive ? "#1A1A1A" : "#B0B0B0",
              transition: "all 0.2s ease",
              "&:hover": item.isActive
                ? {
                    color: "#FD7762",
                    backgroundColor: "#FAFAFA",
                    transform: "translateX(2px)",
                  }
                : {},
            }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
              {item.label}
            </Typography>
            {!item.isActive && (
              <Box
                sx={{
                  fontSize: "0.6rem",
                  px: 1,
                  py: 0.2,
                  borderRadius: "999px",
                  backgroundColor: "#E2B93B",
                  fontWeight: 700,
                  color: "#1A1A1A",
                  letterSpacing: 0.5,
                  textTransform: "uppercase",
                  ml: 1,
                  boxShadow: "inset 0 0 2px rgba(0,0,0,0.1)",
                }}>
                Coming Soon
              </Box>
            )}
          </Box>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default ShopGroupAccordion;
